module.exports = __webpack_public_path__ + "img/juryoffice.6ca5510b.png";